import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ErrorsFromApi } from '@myxplor/ui'

import { fetchWithRetry } from '../authorisation'
import handleErrors from '../io/error-handling'
import PromiseWithCancel from './promise-with-cancel'
import ErrorDisplayFatal from '../ui/error-display-fatal'

const defaultState = {
  loading: false,
  data: [],
  success: false,
  errors: {},
}

// This function takes a component...
const withRemoteRequest = (WrappedComponent, testFetch = false) => {
  // ...and returns another component...
  class ComponentWithRemoteRequest extends React.Component {
    constructor(props) {
      super(props)
      this.state = defaultState
      this.request = { isActive: () => false }
    }

    componentWillUnmount() {
      this.cancelRequest()
    }

    cancelRequest() {
      if (this.request.isActive()) {
        this.request.cancel()
      }
    }

    submitRequest(url, call_params) {
      // So we don't fire off xhr requests during tests
      if (process.env.NODE_ENV === 'test' && !testFetch) return
      this.setState({ loading: true, errors: {}, data: [] })

      this.request = PromiseWithCancel(
        fetchWithRetry(
          url,
          {
            token: this.props.jwt || this.props.token,
            ...call_params,
          },
          this.props.dispatchAction
        )
      )

      this.request.promise
        .then(response =>
          response
            .json()
            .then(payload => (response.ok ? this.onSuccess(payload) : this.onFailure(payload)))
        )
        .catch(error => this.APIFailed(error))
    }

    onSuccess(payload) {
      this.setState({
        loading: false,
        data: payload.data,
        success: true,
        errors: payload.errors ? payload.errors : {},
        apiFailed: false,
      })
    }

    onFailure(payload) {
      this.setState({
        loading: false,
        data: [],
        success: false,
        errors: payload.errors,
        apiFailed: false,
      })
    }

    APIFailed(response) {
      if (this.request.isActive()) {
        this.setState({
          loading: false,
          success: false,
          errors: handleErrors({
            errors: ['Failed to talk to API.', response.message],
          }),
          apiFailed: true,
        })
      }

      if (response.message) {
        this.props.dispatchAction({
          type: 'API_CALL_FAILED',
          notification: {
            message: ErrorsFromApi(response.message),
            message_type: 'error',
          },
        })
      }
    }

    render() {
      if (this.state.apiFailed) {
        return <ErrorDisplayFatal errors={this.state.errors} />
      }

      const { loading, data, success, errors } = this.state
      const remote_request = {
        submit: this.submitRequest.bind(this),
        cancel: this.cancelRequest.bind(this),
        state: {
          loading,
          data,
          success,
          errors,
        },
      }

      return <WrappedComponent remote_request={remote_request} {...this.props} />
    }
  }

  const mapDispatchToProps = dispatch => ({
    dispatchAction: action => dispatch(action),
  })

  const mapStateToProps = state => ({
    jwt: state.authorisation.jwt,
  })

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ComponentWithRemoteRequest)
  )
}

export default withRemoteRequest



// WEBPACK FOOTER //
// ./src/remote-request/index.js